export const SUPERADMINROUTES = [
  { url: 'super-admin/home', txt: 'Dashboard' },
  { url: 'super-admin/inventory-management', txt: 'Inventory' },
  { url: 'super-admin/blogs', txt: 'Blog Posts' },
  { url: 'super-admin/settings', txt: 'Settings' }
]
